"use strict";

exports.__esModule = true;
exports.default = extractParts;

function extractPart(part, from, indexes) {
  if (from > -1) {
    const filteredIndexes = indexes.filter(function (index) {
      return index > -1;
    });

    if (filteredIndexes.length > 0) {
      const min = Math.min(...filteredIndexes);
      return part.slice(from, min);
    } else {
      return part.slice(from);
    }
  } else {
    return undefined;
  }
}
/**
 * @param {string} uri
 * @return {object}
 */


function extractParts(uri) {
  const queryIndex = uri.indexOf("?");
  const fragmentIndex = uri.indexOf("#");
  const path = extractPart(uri, 0, [queryIndex, fragmentIndex]);
  const query = extractPart(uri, queryIndex > -1 ? queryIndex + 1 : -1, [fragmentIndex]);
  const fragment = extractPart(uri, fragmentIndex > -1 ? fragmentIndex + 1 : -1, []);
  return {
    path,
    query,
    fragment
  };
}